import {
  BannerPropsActions,
  BannerPropsMicrocopy,
} from '../../molecules/Banner';
import {
  GalleryPropsActions,
  GalleryPropsData,
  GalleryPropsMicrocopy,
} from '../../molecules/Gallery/Gallery.types';
import { ProductBreadcrumbsPropsData } from '../../molecules/ProductBreadcrumbs/ProductBreadcrumbs.types';
import { SheetsPropsActions } from '../../molecules/Sheets';
import {
  EntitlementConfirmationPropsActions,
  EntitlementConfirmationPropsData,
  EntitlementConfirmationPropsMicrocopy,
} from '../../organisms/EntitlementConfirmation/EntitlementConfirmation.types';
import { LatestUserReviewPropsActions } from '../../organisms/LatestUserReview';
import { PackageListPropsActions } from '../../organisms/PackageList/PackageList.types';
import { ProductCompatibilityTablePropsActions } from '../../organisms/ProductCompatibilityTable';
import {
  ProductInfoPropsActions,
  ProductInfoPropsData,
  ProductInfoPropsMicrocopy,
} from '../../organisms/ProductInfo/ProductInfo.types';
import {
  ProductNutritionLabelsPropsData,
  ProductNutritionLabelsPropsMicrocopy,
} from '../../organisms/ProductNutritionLabels/ProductNutritionLabels.types';
import {
  ProductTabValue,
  ProductTabsPropsData,
  ProductTabsPropsMicrocopy,
} from '../../organisms/ProductTabs/ProductTabs.types';
import {
  PurchasedItemPropsActions,
  PurchasedItemPropsData,
} from '../../organisms/PurchasedItem';
import { PurchasedItemPropsMicrocopy } from '../../organisms/PurchasedItem/PurchasedItem.types';
import {
  RelatedKeywordsPropsActions,
  RelatedKeywordsPropsData,
  RelatedKeywordsPropsMicrocopy,
} from '../../organisms/RelatedKeywords/RelatedKeywords.types';
import { ReleasesSortBy } from '../../organisms/ReleaseList/ReleaseList.types';
import { ReviewListPropsActions } from '../../organisms/ReviewList';

export const ProductStatus = {
  Published: 'published',
  Deprecated: 'deprecated',
  Disabled: 'disabled',
  Draft: 'draft',
} as const;
export type ProductStatusType =
  (typeof ProductStatus)[keyof typeof ProductStatus];

export type UpmProductDetailTemplatePropsMicrocopy = {
  ownedDate: string;
  entitlementConfirmation: EntitlementConfirmationPropsMicrocopy;
  gallery: GalleryPropsMicrocopy;
  productInfo: ProductInfoPropsMicrocopy;
  nutritionLabels: ProductNutritionLabelsPropsMicrocopy;
  tabs: ProductTabsPropsMicrocopy;
  relatedKeywords: RelatedKeywordsPropsMicrocopy;
  purchasedItem?: PurchasedItemPropsMicrocopy;
  banner?: BannerPropsMicrocopy;
  deprecatedBanner: BannerPropsMicrocopy;
};

export type UpmProductDetailTemplatePropsData = {
  wasEntitled: boolean;
  ownedDate?: string;
  status: ProductStatusType;
  currentTab: ProductTabValue;
  breadcrumbs: ProductBreadcrumbsPropsData;
  entitlementConfirmation: EntitlementConfirmationPropsData;
  gallery: GalleryPropsData;
  productInfo: ProductInfoPropsData;
  nutritionLabels: ProductNutritionLabelsPropsData;
  tabs: ProductTabsPropsData;
  relatedKeywords: RelatedKeywordsPropsData;
  purchasedItem: PurchasedItemPropsData;
  canSubmitReview: boolean;
  showServerError?: boolean;
  activeSheetIndex?: number | null;
};

export type UpmProductDetailTemplatePropsDataWithMicrocopy =
  UpmProductDetailTemplatePropsData & {
    microcopy: UpmProductDetailTemplatePropsMicrocopy;
  };

export type UpmProductDetailTemplatePropsActions =
  EntitlementConfirmationPropsActions &
    ProductInfoPropsActions &
    PackageListPropsActions &
    RelatedKeywordsPropsActions &
    GalleryPropsActions &
    ReviewListPropsActions &
    PurchasedItemPropsActions &
    BannerPropsActions &
    LatestUserReviewPropsActions &
    SheetsPropsActions &
    ProductCompatibilityTablePropsActions & {
      onGoToHomepage: () => void;
      onHandleTabChange: (tab: ProductTabValue) => void;
      onAccordionChange?: (name: string, action: 'open' | 'close') => void;
      onReleasesSortChange: (sortBy: ReleasesSortBy) => void;
    };

export type UpmProductDetailTemplateProps =
  UpmProductDetailTemplatePropsDataWithMicrocopy &
    UpmProductDetailTemplatePropsActions & {
      className?: string;
      previewMode?: boolean;
    };
